import React from "react";
import { Button, Modal } from "react-bootstrap";
const Offers = ({
  setChangeOfferModalShow,
  changeOfferModalShow,
  offers = [],
  addOffers = () => {},
  cart,
  variant,
}) => {
  const handleoffers = (offer) => {
    addOffers({ variantId: variant.Id, ...offer });
  };

  return (
    <>
      <Modal
        show={changeOfferModalShow}
        onHide={() => setChangeOfferModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <h5 class="modal-title" id="exampleModalLabel">
            OFFERS AND PROMOTIONS
          </h5>
        </Modal.Header>
        <Modal.Body>
          <ul class="ofr-slider-ul">
            {offers.map((item) => {
              return (
                <li>
                  <div class="ofr-slider-inner-pl">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className="pr-2 pb-0 mb-0 text-dark text-uppercase">
                          <span>"{item.PromotionName}"</span>
                          <br />
                        </p>
                        <p className="p-0 mt-0 pr-2">
                          {" "}
                          {item.PromotionDescription ||
                            "No Description Available."}
                        </p>
                      </div>
                      {cart.appliedCartOffers?.PromotionId ==
                      item?.PromotionId ? (
                        <Button
                          onClick={() => addOffers(null, true)}
                          className="workshop-button-one"
                        >
                          Remove
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleoffers(item)}
                          className="workshop-button-one remove-offer"
                        >
                          Apply
                        </Button>
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Offers;
